import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/",
)({
  component: ContactIndex,
});

function ContactIndex() {
  const { organizationId, opportunityId, contactId } = Route.useParams();
  return (
    <Navigate
      to="/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId/evaluations"
      params={{
        organizationId,
        opportunityId,
        contactId,
      }}
      replace
    />
  );
}
